<template>
    <div id="componentContextMenu" class="dropdown position-absolute" :class="[displayClass, colorClass]" :style="dynamicStyle">
        <i id="componentContextMenuButton" class="fas fa-ellipsis-h dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        </i>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" href="javascript:void(0)" @click="onCopyClick"><i class="fas fa-copy ms-1"></i> Duplicate</a>
            <a class="dropdown-item" href="javascript:void(0)" @click="onRemoveClick"><i class="fas fa-times-circle ms-1"></i> Delete</a>
            <a v-if="component.type === 'Text'" class="dropdown-item" href="javascript:void(0)" @click="onEditClick"><i class="fas fa-pencil ms-1"></i> Edit</a>
            <a v-if="component.type === 'Icon'" class="dropdown-item" href="javascript:void(0)" @click="onEditIconClick"><i class="fas fa-pencil ms-1"></i> Edit</a>
            <a v-if="component.type === 'Image'" class="dropdown-item" href="javascript:void(0)" @click="onEditImageClick"><i class="fas fa-pencil ms-1"></i> Edit</a>
            <a v-if="hasLabel" class="dropdown-item" href="javascript:void(0)" @click="addEmojiClick">😄 Add Emoji</a>
            <a v-if="isComponentWrappable" class="dropdown-item" href="javascript:void(0)" @click="onContainerWrapClick">Wrap in Container</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ComponentEditDropdown',
        props: ['column', 'component', 'layout'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            isComponentWrappable() {
                return this.component.type === 'Label' || this.component.type === 'Link' ||
                    this.component.type === 'Button' || this.component.type === 'Icon'
            },
            hasLabel() {
                return this.component.type === 'Label' || this.component.type === 'Header' ||
                    this.component.type === 'Button'
            },
            dynamicStyle() {
                let positionStyle = this.column.direction === 'column' ? 'top: 0px; right: -15px;' : 'top: -12px; right: 0px;'
                return positionStyle + this.colorStyle
            },
            colorStyle() {
                if(this.isCustomColor) {
                    return 'color: ' + this.component.style.color + ';'
                }

                return ''
            },

            displayClass() {
                return this.column.selected ? 'd-flex' : 'd-none'
            },

            colorClass() {
                if(this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0 ) {
                    return `text-${this.component.style.color}`
                }

                return ''
            },

            isCustomColor() {
                return webase.utils.ui.isCustomColor( this.component )
            },
        },
        beforeUnmount() {
            this.hideDropdown()
        },
        methods: {
            onRemoveClick() {
                for (let j = 0; j < this.column.value.length; j++) {
                    let columnComponent = this.column.value[j]

                    if (columnComponent === this.component) {

                        if(columnComponent.type === 'RowContainer' && columnComponent.value.length > 1 ) {
                            columnComponent.value.splice(columnComponent.value.length - 1, 1)
                        }
                        else {
                            this.column.value.splice(j, 1)
                        }

                        this.layout.selectedComponent = null
                        return
                    }
                }
            },
            onCopyClick() {
                let newComponent = JSON.parse(JSON.stringify(this.component))
                this.layout.selectedColumn.value.push(newComponent)
            },
            onEditClick() {
                this.$emit('editText')
            },
            onEditIconClick() {
                this.$emit('iconClick')
            },
            onEditImageClick() {
                this.$emit('imageClick')
            },
            addEmojiClick() {
                webase.eventDispatcher.emit('addEmojiClick')
            },
            onContainerWrapClick() {
                this.$emit('containerWrapClick')
                this.hideDropdown()
            },
            hideDropdown() {
                //$('#componentContextMenu').dropdown('dispose')
            }
        }
    }
</script>
